module.exports = __webpack_public_path__ + "static/media/logora.54351f09.png";